import React from "react";
import styled from "styled-components";
import Img from "gatsby-image";

export default ({ image, right = false }) => (
  <>
    {image && image.path && (
      <UnevenImgPreview
        src={image.path}
        className="image"
        alt="Preview image"
        right={right}
      />
    )}
    {image && image.childImageSharp && image.childImageSharp.fluid && (
      <UnevenImg
        className="image"
        fluid={image.childImageSharp.fluid}
        alt={image.title}
        right={right}
      />
    )}
  </>
);

const UnevenImg = styled(Img)`
  @media (min-width: 700px) {
    clip-path: ${(props) =>
      props.right
        ? "polygon(0% 0, 88% 0, 100% 100%, 0 100%)"
        : "polygon(0% 0, 100% 0, 100% 100%, 12% 100%)"};
  }
`;

const UnevenImgPreview = styled(UnevenImg).attrs({ as: "img" })`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center center;
`;
